export default {
  mobile: {
    breakpoint: 0,
    containerPadding: '1.5rem',
    containerMaxWidth: 'none',
  },
  mobileLarge: {
    breakpoint: 480,
    containerPadding: '1.5rem',
    containerMaxWidth: 'none',
  },
  tablet: {
    breakpoint: 768,
    containerPadding: '2rem',
    containerMaxWidth: 'none',
  },
  desktop: {
    breakpoint: 1024,
    containerPadding: '3rem',
    containerMaxWidth: 'none',
  },
  desktopLarge: {
    breakpoint: 1440,
    containerPadding: '3rem',
    containerMaxWidth: '1550px',
  },
};
